(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("ort"));
	else if(typeof define === 'function' && define.amd)
		define(["ort"], factory);
	else if(typeof exports === 'object')
		exports["SpeakerVerification"] = factory(require("ort"));
	else
		root["SpeakerVerification"] = factory(root["ort"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__47__) => {
return 